import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class UnixTimeService {

constructor() { }

getEpochData(dateVal) {
const dateMomnt = new Date(dateVal);
return moment(dateMomnt).utc().valueOf();
}

getEpochCurrent() {
const dateMomnt = new Date();
return moment(dateMomnt).utc().valueOf();
}

getRealTime(value) {
return moment.unix(value * 1000).local().toDate();
}

getRealTime2(value) {
return moment.unix(value / 1000).local().toDate();
}

getRealTime3(value) {
return moment.unix(value).local().toDate();
}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/services/unixTime.service.ts